/* SARKAÇ ANALİZİ — 3B kristal sarkaç (Canvas 2D, kütüphanesiz).
   Çift-piramit (bipyramid) kesim taş: üst/alt apeks + kuşak halkası.
   Yüzler normal·ışık ile aydınlatılır, arkadan öne çizilir (painter).
   Modlar: idle (yavaş dönüş+salınım), spin (hızlı dönüş/analiz).
   API: window.OdtSK3B.init(canvas); .mod('idle'|'spin'); .renk('#7c5cbf'); */
(function (g) {
  'use strict';
  var AZ = false; try { AZ = matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function hex(h){ h=h.replace('#',''); return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]; }

  function Kristal(cv){
    this.cv=cv; this.ctx=cv.getContext('2d'); this.mod='idle';
    this.rgb=hex('7c5cbf'); this.t=0; this.calis=true;
    this.kur(); this.dongu();
  }
  Kristal.prototype.kur=function(){
    // bipyramid: N kenarlı kuşak + iki apeks
    var N=7, R=1, ust=1.5, alt=1.7, kus=[];
    for(var i=0;i<N;i++){ var a=i/N*Math.PI*2; kus.push([Math.cos(a)*R,0,Math.sin(a)*R]); }
    var V=[[0,ust,0]].concat(kus).concat([[0,-alt,0]]); // 0=üst apeks, 1..N=kuşak, N+1=alt
    var F=[];
    for(var j=0;j<N;j++){ var n1=1+j, n2=1+(j+1)%N;
      F.push([0,n1,n2]);      // üst yüz
      F.push([N+1,n2,n1]);    // alt yüz
    }
    this.V=V; this.F=F; this.N=N;
  };
  Kristal.prototype.renk=function(h){ this.rgb=hex(h); };
  Kristal.prototype.mod=function(m){ this.mod=m; };
  Kristal.prototype.boyut=function(){
    var dpr=Math.min(g.devicePixelRatio||1,2);
    var w=this.cv.clientWidth||220, h=this.cv.clientHeight||300;
    if(this.cv.width!==Math.round(w*dpr)||this.cv.height!==Math.round(h*dpr)){ this.cv.width=Math.round(w*dpr); this.cv.height=Math.round(h*dpr); }
    this.ctx.setTransform(dpr,0,0,dpr,0,0); return {w:w,h:h};
  };
  Kristal.prototype.dongu=function(){
    var self=this;
    function kare(){
      if(!self.calis) return;
      self.t += AZ?0.004:(self.mod==='spin'?0.09:0.02);
      self.ciz();
      requestAnimationFrame(kare);
    }
    requestAnimationFrame(kare);
  };
  Kristal.prototype.ciz=function(){
    var s=this.boyut(), ctx=this.ctx, w=s.w, h=s.h;
    ctx.clearRect(0,0,w,h);
    var cx=w/2, salin=(this.mod==='spin')?0:Math.sin(this.t*0.9)*0.28; // salınım (radyan)
    var pivotY=h*0.14, boy=h*0.46, gx=cx+Math.sin(salin)*boy, gy=pivotY+Math.cos(salin)*boy; // taş merkezi

    // iplik
    ctx.strokeStyle='rgba(239,233,221,0.35)'; ctx.lineWidth=1.2;
    ctx.beginPath(); ctx.moveTo(cx,pivotY); ctx.lineTo(gx,gy); ctx.stroke();
    ctx.fillStyle='rgba(239,233,221,0.6)'; ctx.beginPath(); ctx.arc(cx,pivotY,2.4,0,7); ctx.fill();

    // taş: 3B döndür + yansıt
    var ay=this.t, ax=Math.sin(this.t*0.5)*0.28, ca=Math.cos(ay),sa=Math.sin(ay),cx2=Math.cos(ax),sx2=Math.sin(ax);
    var olcek=Math.min(w,h)*0.16;
    var L=[0.4,0.7,0.6]; var ll=Math.hypot(L[0],L[1],L[2]); L=[L[0]/ll,L[1]/ll,L[2]/ll];
    var P=this.V.map(function(v){
      var x=v[0]*ca+v[2]*sa, z=-v[0]*sa+v[2]*ca, y=v[1];
      var y2=y*cx2 - z*sx2, z2=y*sx2 + z*cx2;
      var per=1/(3.2+z2);
      return { sx:gx+x*olcek*per*3.2, sy:gy - y2*olcek*per*3.2, z:z2, x:x,y:y2,zz:z2 };
    });
    var self=this;
    var yuzler=this.F.map(function(f){
      var a=P[f[0]],b=P[f[1]],c=P[f[2]];
      // normal (dünya uzayı yaklaşık: ekran uzayında cross)
      var ux=b.x-a.x,uy=b.y-a.y,uz=b.zz-a.zz, vx=c.x-a.x,vy=c.y-a.y,vz=c.zz-a.zz;
      var nx=uy*vz-uz*vy, ny=uz*vx-ux*vz, nz=ux*vy-uy*vx, nl=Math.hypot(nx,ny,nz)||1;
      var isik=Math.max(0,(nx*L[0]+ny*L[1]+nz*L[2])/nl);
      return { p:[a,b,c], zort:(a.z+b.z+c.z)/3, isik:isik };
    }).sort(function(A,B){ return A.zort-B.zort; }); // arkadan öne
    var R=self.rgb;
    // hafif dış parıltı
    var grd=ctx.createRadialGradient(gx,gy,2,gx,gy,olcek*2.6);
    grd.addColorStop(0,'rgba('+R[0]+','+R[1]+','+R[2]+',0.5)'); grd.addColorStop(1,'rgba('+R[0]+','+R[1]+','+R[2]+',0)');
    ctx.fillStyle=grd; ctx.fillRect(gx-olcek*3,gy-olcek*3,olcek*6,olcek*6);
    yuzler.forEach(function(y){
      var t=0.28+y.isik*0.9;
      var r=Math.min(255,R[0]*t+70*y.isik), gg=Math.min(255,R[1]*t+70*y.isik), bb=Math.min(255,R[2]*t+90*y.isik);
      ctx.beginPath(); ctx.moveTo(y.p[0].sx,y.p[0].sy); ctx.lineTo(y.p[1].sx,y.p[1].sy); ctx.lineTo(y.p[2].sx,y.p[2].sy); ctx.closePath();
      ctx.fillStyle='rgba('+(r|0)+','+(gg|0)+','+(bb|0)+',0.92)'; ctx.fill();
      ctx.strokeStyle='rgba(255,255,255,'+(0.05+y.isik*0.22)+')'; ctx.lineWidth=0.7; ctx.stroke();
    });
  };

  g.OdtSK3B = {
    inst:null,
    init:function(cv){ if(!cv)return; this.inst=new Kristal(cv); return this.inst; },
    mod:function(m){ if(this.inst)this.inst.mod=m; },
    renk:function(h){ if(this.inst)this.inst.renk(h); }
  };
})(window);
